import { render, staticRenderFns } from "./dialog.vue?vue&type=template&id=4774cece&scoped=true&"
import script from "./dialog.vue?vue&type=script&lang=ts&"
export * from "./dialog.vue?vue&type=script&lang=ts&"
import style0 from "styles/pages/visit/account-manage.less?vue&type=style&index=0&id=4774cece&lang=less&scoped=true&"
import style1 from "./dialog.vue?vue&type=style&index=1&id=4774cece&lang=less&scoped=true&"
import style2 from "./dialog.vue?vue&type=style&index=2&id=4774cece&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4774cece",
  null
  
)

export default component.exports